import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { SelectItem, Select } from "../Select/Select";
import styles from "./PagerSelect.module.less";

export type PagerSelectOption = {
	value: number;
	label: string;
};

export type PagerSelectProps = {
	value: number;
	onChange: (newValue: number) => void;
	options: ReadonlyArray<PagerSelectOption>;
	trackingId?: string;
};

export const PagerSelect = (props: PagerSelectProps): ReactElement => {
	const {
		value,
		onChange,
		options,
		trackingId
	} = props;

	const selectOptions : SelectItem<Number>[] = options.map(
		o => ({
			value: o.value,
			text: o.label,
			valueTrackingId: `option-${o.value}`
		})
	);

	return (
		<div className={styles.root}>
			<Select
				value={value}
				options={selectOptions}
				onChange={onChange}
				trackingId={trackingId}
				menuTitle={localize("_Pages")}
			/>
		</div>
	);
};

PagerSelect.displayName = "PagerSelect";